module.exports = __webpack_public_path__ + "static/about-content-image-2-2e9993afb257cb7930d3399b190f78e2.jpg";